export default __webpack_public_path__ + "img/op-sand-strategy-dry-conveyor.7592df56.png";